/**
 * Inservice External Integrations
 * Inservice external integrations API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { CapacitorHttp } from '@capacitor/core';
import { HttpParameterCodec, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import Session from 'supertokens-web-js/recipe/session';
import { AuthStrategy } from '@generator-strategies/auth-strategy';
import { LanguageStrategy } from '@generator-strategies/language-strategy';
import { TenantStrategy } from '@generator-strategies/tenant-strategy';

// @ts-ignore
import { AppointmentResponseDto } from '../model/appointmentResponseDto';
// @ts-ignore
import { CheckAllSlotStatusReqDto } from '../model/checkAllSlotStatusReqDto';
// @ts-ignore
import { CheckSlotStatusReqDto } from '../model/checkSlotStatusReqDto';
// @ts-ignore
import { CheckedSlotResponseDto } from '../model/checkedSlotResponseDto';
// @ts-ignore
import { CheckinLinesReqDto } from '../model/checkinLinesReqDto';
// @ts-ignore
import { CheckinLinesResponseDto } from '../model/checkinLinesResponseDto';
// @ts-ignore
import { CreateAppointmentDto } from '../model/createAppointmentDto';
// @ts-ignore
import { CreateScheduleReqDto } from '../model/createScheduleReqDto';
// @ts-ignore
import { CreateScheduleResponseDto } from '../model/createScheduleResponseDto';
// @ts-ignore
import { DeleteSlotStatusReqDto } from '../model/deleteSlotStatusReqDto';
// @ts-ignore
import { DeleteSlotStatusResponseDto } from '../model/deleteSlotStatusResponseDto';
// @ts-ignore
import { GetAppointmentResponseDto } from '../model/getAppointmentResponseDto';
// @ts-ignore
import { GetCheckinLinesBulkReqDto } from '../model/getCheckinLinesBulkReqDto';
// @ts-ignore
import { GetCheckinLinesBulkResponseDto } from '../model/getCheckinLinesBulkResponseDto';
// @ts-ignore
import { GetDaySlotsReqDto } from '../model/getDaySlotsReqDto';
// @ts-ignore
import { GetDaySlotsResponseDto } from '../model/getDaySlotsResponseDto';
// @ts-ignore
import { GetOrCreateRevspringUserReqDto } from '../model/getOrCreateRevspringUserReqDto';
// @ts-ignore
import { GetSlotsBySchedulesReqDto } from '../model/getSlotsBySchedulesReqDto';
// @ts-ignore
import { GetSlotsBySchedulesResponseDto } from '../model/getSlotsBySchedulesResponseDto';
// @ts-ignore
import { IAppointment } from '../model/iAppointment';
// @ts-ignore
import { InsertSlotStatusReqDto } from '../model/insertSlotStatusReqDto';
// @ts-ignore
import { InsertSlotStatusResponseDto } from '../model/insertSlotStatusResponseDto';
// @ts-ignore
import { RevspringUserResponseDto } from '../model/revspringUserResponseDto';
// @ts-ignore
import { UpdateCheckinStatusReqDto } from '../model/updateCheckinStatusReqDto';
// @ts-ignore
import { UpdateRevspringUserReqDto } from '../model/updateRevspringUserReqDto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

@Injectable({
  providedIn: 'root'
})
export class NLSchedulingService {
  protected basePath = 'http://localhost';
  public defaultHeaders: any = {};
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    @Optional()@Inject(BASE_PATH) basePath: string|string[],
    @Optional() configuration: Configuration,
    @Optional() private readonly authStrategy: AuthStrategy,
    @Optional() private readonly languageStrategy: LanguageStrategy,
    @Optional() private readonly tenantStrategy: TenantStrategy,
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      if (Array.isArray(basePath) && basePath.length > 0) {
        basePath = basePath[0];
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }


  /**
   * @param xTENANTID
   * @param createAppointmentDto
   */
  public async nlSchedulingControllerBookAppointment(xTENANTID: string, createAppointmentDto: CreateAppointmentDto, ): Promise<AppointmentResponseDto> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling nlSchedulingControllerBookAppointment.');
    }
    if (createAppointmentDto === null || createAppointmentDto === undefined) {
      throw new Error('Required parameter createAppointmentDto was null or undefined when calling nlSchedulingControllerBookAppointment.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/external-integrations/nl-scheduling/book-appointment`,
        data: createAppointmentDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * @param xTENANTID
   * @param checkAllSlotStatusReqDto
   */
  public async nlSchedulingControllerCheckAllSlotStatus(xTENANTID: string, checkAllSlotStatusReqDto: CheckAllSlotStatusReqDto, ): Promise<Array<CheckedSlotResponseDto>> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling nlSchedulingControllerCheckAllSlotStatus.');
    }
    if (checkAllSlotStatusReqDto === null || checkAllSlotStatusReqDto === undefined) {
      throw new Error('Required parameter checkAllSlotStatusReqDto was null or undefined when calling nlSchedulingControllerCheckAllSlotStatus.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/external-integrations/nl-scheduling/check-all-slot-status`,
        data: checkAllSlotStatusReqDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * @param xTENANTID
   * @param checkSlotStatusReqDto
   */
  public async nlSchedulingControllerCheckSlotStatus(xTENANTID: string, checkSlotStatusReqDto: CheckSlotStatusReqDto, ): Promise<CheckedSlotResponseDto> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling nlSchedulingControllerCheckSlotStatus.');
    }
    if (checkSlotStatusReqDto === null || checkSlotStatusReqDto === undefined) {
      throw new Error('Required parameter checkSlotStatusReqDto was null or undefined when calling nlSchedulingControllerCheckSlotStatus.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/external-integrations/nl-scheduling/check-slot-status`,
        data: checkSlotStatusReqDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * @param xTENANTID
   * @param createScheduleReqDto
   */
  public async nlSchedulingControllerCreateSchedule(xTENANTID: string, createScheduleReqDto: CreateScheduleReqDto, ): Promise<CreateScheduleResponseDto> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling nlSchedulingControllerCreateSchedule.');
    }
    if (createScheduleReqDto === null || createScheduleReqDto === undefined) {
      throw new Error('Required parameter createScheduleReqDto was null or undefined when calling nlSchedulingControllerCreateSchedule.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/external-integrations/nl-scheduling/create-schedule`,
        data: createScheduleReqDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * @param xTENANTID
   * @param deleteSlotStatusReqDto
   */
  public async nlSchedulingControllerDeleteSlotStatus(xTENANTID: string, deleteSlotStatusReqDto: DeleteSlotStatusReqDto, ): Promise<DeleteSlotStatusResponseDto> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling nlSchedulingControllerDeleteSlotStatus.');
    }
    if (deleteSlotStatusReqDto === null || deleteSlotStatusReqDto === undefined) {
      throw new Error('Required parameter deleteSlotStatusReqDto was null or undefined when calling nlSchedulingControllerDeleteSlotStatus.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/external-integrations/nl-scheduling/delete-slot-status`,
        data: deleteSlotStatusReqDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * @param xTENANTID
   */
  public async nlSchedulingControllerGetAllSchedules(xTENANTID: string, ): Promise<Array<IAppointment>> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling nlSchedulingControllerGetAllSchedules.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.get({
      url: `${this.configuration.basePath}/api/external-integrations/nl-scheduling/get-all-schedules`,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * @param xTENANTID
   * @param prodOrgID
   * @param testOrgID
   * @param scheduleDay
   */
  public async nlSchedulingControllerGetAppointments(xTENANTID: string, prodOrgID: string, testOrgID: string, scheduleDay: string, ): Promise<GetAppointmentResponseDto> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling nlSchedulingControllerGetAppointments.');
    }
    if (prodOrgID === null || prodOrgID === undefined) {
      throw new Error('Required parameter prodOrgID was null or undefined when calling nlSchedulingControllerGetAppointments.');
    }
    if (testOrgID === null || testOrgID === undefined) {
      throw new Error('Required parameter testOrgID was null or undefined when calling nlSchedulingControllerGetAppointments.');
    }
    if (scheduleDay === null || scheduleDay === undefined) {
      throw new Error('Required parameter scheduleDay was null or undefined when calling nlSchedulingControllerGetAppointments.');
    }

    const localVarQueryParameters = new URLSearchParams();
    if (prodOrgID !== undefined && prodOrgID !== null) {
      localVarQueryParameters.append('prodOrgID', String(prodOrgID));
    }
    if (testOrgID !== undefined && testOrgID !== null) {
      localVarQueryParameters.append('testOrgID', String(testOrgID));
    }
    if (scheduleDay !== undefined && scheduleDay !== null) {
      localVarQueryParameters.append('scheduleDay', String(scheduleDay));
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const queryString = localVarQueryParameters.toString();
    const urlWithParams = queryString ? `${this.configuration.basePath}/api/external-integrations/nl-scheduling/get-appointments?${queryString}` : `${this.configuration.basePath}/api/external-integrations/nl-scheduling/get-appointments`;
    const response = await CapacitorHttp.get({
      url: urlWithParams,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * @param xTENANTID
   * @param checkinLinesReqDto
   */
  public async nlSchedulingControllerGetCheckinLines(xTENANTID: string, checkinLinesReqDto: CheckinLinesReqDto, ): Promise<CheckinLinesResponseDto> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling nlSchedulingControllerGetCheckinLines.');
    }
    if (checkinLinesReqDto === null || checkinLinesReqDto === undefined) {
      throw new Error('Required parameter checkinLinesReqDto was null or undefined when calling nlSchedulingControllerGetCheckinLines.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/external-integrations/nl-scheduling/get-checkin-lines`,
        data: checkinLinesReqDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * @param xTENANTID
   * @param getCheckinLinesBulkReqDto
   */
  public async nlSchedulingControllerGetCheckinLinesBulk(xTENANTID: string, getCheckinLinesBulkReqDto: GetCheckinLinesBulkReqDto, ): Promise<GetCheckinLinesBulkResponseDto> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling nlSchedulingControllerGetCheckinLinesBulk.');
    }
    if (getCheckinLinesBulkReqDto === null || getCheckinLinesBulkReqDto === undefined) {
      throw new Error('Required parameter getCheckinLinesBulkReqDto was null or undefined when calling nlSchedulingControllerGetCheckinLinesBulk.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/external-integrations/nl-scheduling/get-checkin-lines-bulk`,
        data: getCheckinLinesBulkReqDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * @param xTENANTID
   * @param getDaySlotsReqDto
   */
  public async nlSchedulingControllerGetDaySlots(xTENANTID: string, getDaySlotsReqDto: GetDaySlotsReqDto, ): Promise<GetDaySlotsResponseDto> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling nlSchedulingControllerGetDaySlots.');
    }
    if (getDaySlotsReqDto === null || getDaySlotsReqDto === undefined) {
      throw new Error('Required parameter getDaySlotsReqDto was null or undefined when calling nlSchedulingControllerGetDaySlots.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/external-integrations/nl-scheduling/get-day-slots`,
        data: getDaySlotsReqDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * @param xTENANTID
   */
  public async nlSchedulingControllerGetHealthCoachAppointments(xTENANTID: string, ): Promise<Array<IAppointment>> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling nlSchedulingControllerGetHealthCoachAppointments.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.get({
      url: `${this.configuration.basePath}/api/external-integrations/nl-scheduling/get-health-coach-appointments`,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * @param xTENANTID
   * @param getOrCreateRevspringUserReqDto
   */
  public async nlSchedulingControllerGetOrCreateUser(xTENANTID: string, getOrCreateRevspringUserReqDto: GetOrCreateRevspringUserReqDto, ): Promise<RevspringUserResponseDto> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling nlSchedulingControllerGetOrCreateUser.');
    }
    if (getOrCreateRevspringUserReqDto === null || getOrCreateRevspringUserReqDto === undefined) {
      throw new Error('Required parameter getOrCreateRevspringUserReqDto was null or undefined when calling nlSchedulingControllerGetOrCreateUser.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/external-integrations/nl-scheduling/current-user`,
        data: getOrCreateRevspringUserReqDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * @param xTENANTID
   * @param getSlotsBySchedulesReqDto
   */
  public async nlSchedulingControllerGetSlotsBySchedules(xTENANTID: string, getSlotsBySchedulesReqDto: GetSlotsBySchedulesReqDto, ): Promise<GetSlotsBySchedulesResponseDto> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling nlSchedulingControllerGetSlotsBySchedules.');
    }
    if (getSlotsBySchedulesReqDto === null || getSlotsBySchedulesReqDto === undefined) {
      throw new Error('Required parameter getSlotsBySchedulesReqDto was null or undefined when calling nlSchedulingControllerGetSlotsBySchedules.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/external-integrations/nl-scheduling/get-slots-by-schedules`,
        data: getSlotsBySchedulesReqDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * @param xTENANTID
   */
  public async nlSchedulingControllerGetVirtualAppointments(xTENANTID: string, ): Promise<Array<IAppointment>> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling nlSchedulingControllerGetVirtualAppointments.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.get({
      url: `${this.configuration.basePath}/api/external-integrations/nl-scheduling/get-virtual-appointments`,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * @param xTENANTID
   * @param insertSlotStatusReqDto
   */
  public async nlSchedulingControllerInsertSlotStatus(xTENANTID: string, insertSlotStatusReqDto: InsertSlotStatusReqDto, ): Promise<InsertSlotStatusResponseDto> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling nlSchedulingControllerInsertSlotStatus.');
    }
    if (insertSlotStatusReqDto === null || insertSlotStatusReqDto === undefined) {
      throw new Error('Required parameter insertSlotStatusReqDto was null or undefined when calling nlSchedulingControllerInsertSlotStatus.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/external-integrations/nl-scheduling/insert-slot-status`,
        data: insertSlotStatusReqDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * @param xTENANTID
   * @param updateCheckinStatusReqDto
   */
  public async nlSchedulingControllerUpdateCheckinStatus(xTENANTID: string, updateCheckinStatusReqDto: UpdateCheckinStatusReqDto, ): Promise<any> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling nlSchedulingControllerUpdateCheckinStatus.');
    }
    if (updateCheckinStatusReqDto === null || updateCheckinStatusReqDto === undefined) {
      throw new Error('Required parameter updateCheckinStatusReqDto was null or undefined when calling nlSchedulingControllerUpdateCheckinStatus.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/external-integrations/nl-scheduling/update-checkin-status`,
        data: updateCheckinStatusReqDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * @param xTENANTID
   * @param updateRevspringUserReqDto
   */
  public async nlSchedulingControllerUpdateRevspringUser(xTENANTID: string, updateRevspringUserReqDto: UpdateRevspringUserReqDto, ): Promise<RevspringUserResponseDto> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling nlSchedulingControllerUpdateRevspringUser.');
    }
    if (updateRevspringUserReqDto === null || updateRevspringUserReqDto === undefined) {
      throw new Error('Required parameter updateRevspringUserReqDto was null or undefined when calling nlSchedulingControllerUpdateRevspringUser.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/external-integrations/nl-scheduling/update-user`,
        data: updateRevspringUserReqDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
}
